import { useDispatch, useSelector } from 'react-redux';

// Custom hook for typed dispatch and selector
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;

// Auth hooks
export const useAuth = () => {
  return useAppSelector((state) => state.auth);
};

export const useUser = () => {
  return useAppSelector((state) => state.user);
};

export const useUI = () => {
  return useAppSelector((state) => state.ui);
};

// Specific selectors
export const useIsAuthenticated = () => {
  return useAppSelector((state) => state.auth.isAuthenticated);
};

export const useCurrentUser = () => {
  return useAppSelector((state) => state.auth.user);
};

export const useUserProfile = () => {
  return useAppSelector((state) => state.user.profile);
};

export const useDashboardInfo = () => {
  return useAppSelector((state) => state.user.dashboardInfo);
};

export const useSupportTickets = () => {
  return useAppSelector((state) => state.user.tickets);
};

export const useLoading = () => {
  const authLoading = useAppSelector((state) => state.auth.loading);
  const userLoading = useAppSelector((state) => state.user.loading);
  const uiLoading = useAppSelector((state) => state.ui.isLoading);
  
  return authLoading || userLoading || uiLoading;
};

export const useError = () => {
  const authError = useAppSelector((state) => state.auth.error);
  const userError = useAppSelector((state) => state.user.error);
  
  return authError || userError;
};

export const useSidebar = () => {
  return useAppSelector((state) => state.ui.sidebarOpen);
};

export const useTheme = () => {
  return useAppSelector((state) => state.ui.theme);
};

export const useModal = () => {
  return useAppSelector((state) => state.ui.modal);
}; 